skrilla.filter('dateTimeFormatter', function(dateService) {
    return function(dateString, format) {
        if(dateString !== undefined && dateString !== null) {
            let dateTime = moment.utc(dateString);

            let ago = ""
            if (Object.values(arguments).includes('ago')) {
                ago = " (" + dateTime.fromNow() + ")";
            }
            const timezone_ = dateService.getTimeZonePreference();

            dateTime = dateTime.utc().add(timezone_.offset, "minutes");
            if (Array.isArray(format)) {
                format = format[0];
            }
            if (format === undefined) {
                format = "DD-MM-yyyy HH:mm:ss";
            }

            const res = dateTime.format(format)
            return res + ago;
        }
        return "";
    };
})
